var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChineseNy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 19,
    viewBox: "0 0 119 19",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.24 4.08789C117.16 5.01302 116.144 5.98145 115.191 6.99316C114.239 8.00033 113.373 9.07129 112.594 10.2061C112.585 10.2744 112.58 10.3451 112.58 10.418C112.58 10.4863 112.58 10.5547 112.58 10.623C112.58 11.2656 112.648 11.8831 112.785 12.4756C112.926 13.068 113.125 13.6423 113.38 14.1982C112.842 14.0387 112.311 13.918 111.787 13.8359C111.263 13.7493 110.73 13.7061 110.188 13.7061C109.481 13.7061 108.777 13.7767 108.075 13.918C108.385 13.2754 108.638 12.626 108.834 11.9697C109.035 11.3135 109.164 10.6367 109.224 9.93945C108.654 8.86393 107.991 7.86133 107.234 6.93164C106.482 6.00195 105.623 5.1429 104.657 4.35449C105.04 4.41829 105.414 4.46842 105.778 4.50488C106.143 4.53678 106.498 4.55273 106.845 4.55273C107.269 4.55273 107.674 4.52767 108.062 4.47754C108.449 4.42285 108.823 4.33854 109.183 4.22461C109.392 4.89453 109.657 5.51204 109.976 6.07715C110.299 6.6377 110.682 7.14583 111.124 7.60156C111.612 7.13216 112.017 6.61263 112.341 6.04297C112.669 5.47331 112.936 4.84896 113.141 4.16992C113.496 4.25651 113.856 4.31803 114.221 4.35449C114.59 4.39095 114.973 4.40918 115.369 4.40918C115.82 4.40918 116.283 4.38411 116.757 4.33398C117.235 4.28385 117.73 4.20182 118.24 4.08789Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.115 4.58008C104.459 5.40039 103.96 6.27539 103.618 7.20508C103.281 8.13477 103.112 9.13509 103.112 10.2061C103.112 10.7575 103.158 11.3249 103.249 11.9082C103.34 12.487 103.481 13.0863 103.673 13.7061C103.295 13.7197 102.91 13.7562 102.518 13.8154C102.18 13.8656 101.809 13.9453 101.403 14.0547C100.998 14.1641 100.601 14.319 100.214 14.5195C100.082 14.1322 99.9359 13.7607 99.7764 13.4053C99.6169 13.0452 99.4528 12.7057 99.2842 12.3867C99.1156 12.0677 98.9447 11.7692 98.7715 11.4912C98.6029 11.2132 98.4411 10.958 98.2861 10.7256C97.917 10.1833 97.5433 9.69792 97.165 9.26953C97.1605 9.26497 97.1536 9.25586 97.1445 9.24219C97.1354 9.23307 97.1263 9.22396 97.1172 9.21484C97.1081 9.20117 97.099 9.18522 97.0898 9.16699C97.1172 9.56348 97.1309 9.95085 97.1309 10.3291C97.1309 11.7236 96.9508 13.0977 96.5908 14.4512C95.7979 14.1686 94.9798 14.0273 94.1367 14.0273C93.8678 14.0273 93.5944 14.041 93.3164 14.0684C93.043 14.0957 92.7673 14.139 92.4893 14.1982C93.141 13.387 93.6354 12.5166 93.9727 11.5869C94.3145 10.6572 94.4854 9.64551 94.4854 8.55176C94.4854 8.18717 94.4648 7.81348 94.4238 7.43066C94.3874 7.04785 94.3304 6.65592 94.2529 6.25488C93.9567 6.00879 93.6377 5.75814 93.2959 5.50293C92.9541 5.24772 92.5872 4.98568 92.1953 4.7168C92.6191 4.77604 93.0247 4.80111 93.4121 4.79199C93.804 4.78288 94.1914 4.73958 94.5742 4.66211C94.957 4.58008 95.3444 4.46615 95.7363 4.32031C96.1283 4.17448 96.5384 3.99447 96.9668 3.78027L100.617 10.3428C100.553 9.93717 100.506 9.53841 100.474 9.14648C100.442 8.75456 100.426 8.36491 100.426 7.97754C100.426 7.13444 100.508 6.32096 100.672 5.53711C100.84 4.75326 101.107 3.99902 101.472 3.27441C102.561 4.0446 103.775 4.47982 105.115 4.58008Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4355 13.9727C80.9661 13.9727 80.5446 13.9749 80.1709 13.9795C79.7972 13.9795 79.4486 13.9886 79.125 14.0068C78.806 14.0296 78.5007 14.0615 78.209 14.1025C77.9219 14.1481 77.6257 14.2119 77.3203 14.2939C77.6029 13.4326 77.8148 12.5827 77.9561 11.7441C78.1019 10.901 78.1748 10.0579 78.1748 9.21484C78.1748 8.45378 78.1133 7.68359 77.9902 6.9043C77.7077 6.86328 77.4274 6.8291 77.1494 6.80176H77.1221L77.9355 6.59668L77.792 5.90625C78.0609 5.98372 78.3252 6.05436 78.585 6.11816C78.8447 6.18197 79.109 6.23893 79.3779 6.28906C80.1436 6.14779 80.9137 6.04069 81.6885 5.96777C82.4678 5.8903 83.2562 5.85156 84.0537 5.85156C84.4046 5.85156 84.7555 5.86068 85.1064 5.87891C85.4619 5.89714 85.8424 5.91992 86.248 5.94727C86.1523 6.28906 86.0794 6.63086 86.0293 6.97266C85.9792 7.31445 85.9541 7.66536 85.9541 8.02539C85.9541 8.13477 85.9564 8.26237 85.9609 8.4082C85.9701 8.54948 85.986 8.70443 86.0088 8.87305C85.2295 8.57682 84.4502 8.3125 83.6709 8.08008C82.8916 7.8431 82.0986 7.63802 81.292 7.46484C81.2555 7.77474 81.2259 8.08236 81.2031 8.3877C81.1849 8.69303 81.1689 9.00065 81.1553 9.31055C81.5426 9.23763 81.9368 9.18522 82.3379 9.15332C82.7435 9.11686 83.165 9.09408 83.6025 9.08496C83.5615 9.25358 83.5273 9.4222 83.5 9.59082C83.4772 9.75944 83.4658 9.93262 83.4658 10.1104C83.4658 10.3747 83.5068 10.6732 83.5889 11.0059C83.1787 10.8372 82.7731 10.6823 82.3721 10.541C81.971 10.3952 81.5654 10.2653 81.1553 10.1514C81.1553 10.5205 81.1621 10.9056 81.1758 11.3066C81.1895 11.7031 81.2145 12.1019 81.251 12.5029C82.0303 12.3981 82.8141 12.2591 83.6025 12.0859C84.391 11.9082 85.193 11.6917 86.0088 11.4365C85.9541 11.7327 85.9108 12.0221 85.8789 12.3047C85.847 12.5827 85.8311 12.8493 85.8311 13.1045C85.8311 13.5876 85.8857 14.082 85.9951 14.5879C85.2204 14.4147 84.4548 14.2666 83.6982 14.1436C82.9463 14.0205 82.1829 13.9202 81.4082 13.8428L81.4355 13.9727Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4248 10.2607C76.4385 10.3382 76.4453 10.4157 76.4453 10.4932C76.4499 10.5706 76.4521 10.6481 76.4521 10.7256C76.4521 11.1084 76.3838 11.4684 76.2471 11.8057C76.1149 12.1383 75.9303 12.446 75.6934 12.7285C75.4609 13.0065 75.1829 13.2572 74.8594 13.4805C74.5358 13.7038 74.1872 13.8906 73.8135 14.041C73.4398 14.196 73.0479 14.3145 72.6377 14.3965C72.2275 14.4785 71.8151 14.5195 71.4004 14.5195C71.1178 14.5195 70.8307 14.5059 70.5391 14.4785C70.252 14.4512 69.9626 14.4352 69.6709 14.4307C69.3838 14.4261 69.0944 14.4443 68.8027 14.4854C68.5156 14.5264 68.2285 14.613 67.9414 14.7451C67.7819 14.2074 67.6133 13.7243 67.4355 13.2959C67.2624 12.863 67.1029 12.4938 66.957 12.1885C66.7839 11.833 66.613 11.5186 66.4443 11.2451C66.973 11.4912 67.4902 11.6895 67.9961 11.8398C68.502 11.9857 68.9759 12.0973 69.418 12.1748C69.8646 12.2523 70.2656 12.3024 70.6211 12.3252C70.9766 12.348 71.2682 12.3594 71.4961 12.3594C71.7148 12.3594 71.9359 12.3503 72.1592 12.332C72.387 12.3092 72.6149 12.2728 72.8428 12.2227C72.6696 12.0312 72.4668 11.874 72.2344 11.751C72.002 11.6234 71.7513 11.514 71.4824 11.4229C71.2181 11.3317 70.9401 11.2497 70.6484 11.1768C70.3613 11.1038 70.0765 11.0264 69.7939 10.9443C69.5114 10.8577 69.238 10.7598 68.9736 10.6504C68.7093 10.5365 68.4678 10.3929 68.249 10.2197C67.9801 10.0101 67.7842 9.77083 67.6611 9.50195C67.5381 9.23307 67.4629 8.94141 67.4355 8.62695C67.2806 8.68164 67.1439 8.73633 67.0254 8.79102C66.9069 8.84115 66.8066 8.88444 66.7246 8.9209C66.6289 8.96647 66.5446 9.00749 66.4717 9.04395C66.6221 8.63379 66.8294 8.27148 67.0938 7.95703C67.3626 7.64258 67.6634 7.36914 67.9961 7.13672C68.3288 6.9043 68.682 6.70833 69.0557 6.54883C69.4339 6.38932 69.8076 6.25716 70.1768 6.15234C71.0426 5.91081 71.9769 5.77409 72.9795 5.74219C73.2757 5.73763 73.5993 5.72624 73.9502 5.70801C74.251 5.68978 74.5996 5.66243 74.9961 5.62598C75.3971 5.58952 75.8255 5.53483 76.2812 5.46191C76.1628 5.63053 76.0648 5.8151 75.9873 6.01562C75.9144 6.21615 75.8574 6.42122 75.8164 6.63086C75.7754 6.84049 75.7458 7.04785 75.7275 7.25293C75.7139 7.45345 75.707 7.6403 75.707 7.81348C75.707 7.92285 75.7093 8.02767 75.7139 8.12793C75.7184 8.22819 75.7253 8.31706 75.7344 8.39453C75.7435 8.48568 75.7549 8.57227 75.7686 8.6543C74.9984 8.33984 74.2692 8.11882 73.5811 7.99121C72.8929 7.86361 72.2435 7.7998 71.6328 7.7998C71.4505 7.7998 71.2751 7.80664 71.1064 7.82031C70.9378 7.82943 70.7692 7.84082 70.6006 7.85449C70.637 8.03223 70.7054 8.18034 70.8057 8.29883C70.9105 8.41732 71.0153 8.51302 71.1201 8.58594C71.2432 8.66797 71.3776 8.73177 71.5234 8.77734C71.8333 8.86393 72.1683 8.97103 72.5283 9.09863C72.8929 9.22624 73.2552 9.38118 73.6152 9.56348C73.9798 9.74121 74.3262 9.95312 74.6543 10.1992C74.987 10.4408 75.2786 10.7233 75.5293 11.0469C75.6842 10.9329 75.8369 10.8099 75.9873 10.6777C76.1377 10.5456 76.2835 10.4066 76.4248 10.2607Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9688 13.9727C60.4993 13.9727 60.0778 13.9749 59.7041 13.9795C59.3304 13.9795 58.9818 13.9886 58.6582 14.0068C58.3392 14.0296 58.0339 14.0615 57.7422 14.1025C57.4551 14.1481 57.1589 14.2119 56.8535 14.2939C57.1361 13.4326 57.348 12.5827 57.4893 11.7441C57.6351 10.901 57.708 10.0579 57.708 9.21484C57.708 8.45378 57.6465 7.68359 57.5234 6.9043C57.2409 6.86328 56.9606 6.8291 56.6826 6.80176H56.6553L57.4688 6.59668L57.3252 5.90625C57.5941 5.98372 57.8584 6.05436 58.1182 6.11816C58.3779 6.18197 58.6423 6.23893 58.9111 6.28906C59.6768 6.14779 60.4469 6.04069 61.2217 5.96777C62.001 5.8903 62.7894 5.85156 63.5869 5.85156C63.9378 5.85156 64.2887 5.86068 64.6396 5.87891C64.9951 5.89714 65.3757 5.91992 65.7812 5.94727C65.6855 6.28906 65.6126 6.63086 65.5625 6.97266C65.5124 7.31445 65.4873 7.66536 65.4873 8.02539C65.4873 8.13477 65.4896 8.26237 65.4941 8.4082C65.5033 8.54948 65.5192 8.70443 65.542 8.87305C64.7627 8.57682 63.9834 8.3125 63.2041 8.08008C62.4248 7.8431 61.6318 7.63802 60.8252 7.46484C60.7887 7.77474 60.7591 8.08236 60.7363 8.3877C60.7181 8.69303 60.7021 9.00065 60.6885 9.31055C61.0758 9.23763 61.4701 9.18522 61.8711 9.15332C62.2767 9.11686 62.6982 9.09408 63.1357 9.08496C63.0947 9.25358 63.0605 9.4222 63.0332 9.59082C63.0104 9.75944 62.999 9.93262 62.999 10.1104C62.999 10.3747 63.04 10.6732 63.1221 11.0059C62.7119 10.8372 62.3063 10.6823 61.9053 10.541C61.5042 10.3952 61.0986 10.2653 60.6885 10.1514C60.6885 10.5205 60.6953 10.9056 60.709 11.3066C60.7227 11.7031 60.7477 12.1019 60.7842 12.5029C61.5635 12.3981 62.3473 12.2591 63.1357 12.0859C63.9242 11.9082 64.7262 11.6917 65.542 11.4365C65.4873 11.7327 65.444 12.0221 65.4121 12.3047C65.3802 12.5827 65.3643 12.8493 65.3643 13.1045C65.3643 13.5876 65.4189 14.082 65.5283 14.5879C64.7536 14.4147 63.988 14.2666 63.2314 14.1436C62.4795 14.0205 61.7161 13.9202 60.9414 13.8428L60.9688 13.9727Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4707 6.4668C55.9056 7.10938 55.4772 7.80436 55.1855 8.55176C54.8939 9.2946 54.748 10.099 54.748 10.9648C54.748 11.4206 54.7868 11.8809 54.8643 12.3457C54.9417 12.8105 55.0625 13.2822 55.2266 13.7607C54.8802 13.7699 54.5202 13.8018 54.1465 13.8564C53.8275 13.9066 53.4743 13.9795 53.0869 14.0752C52.6995 14.1755 52.319 14.3145 51.9453 14.4922C51.6582 13.7448 51.305 13.0316 50.8857 12.3525C50.4665 11.6735 49.9902 11.0286 49.457 10.418C49.5117 11.7077 49.3568 13.0407 48.9922 14.417C48.1628 14.1572 47.4017 14.0273 46.709 14.0273C46.4857 14.0273 46.2419 14.041 45.9775 14.0684C45.7132 14.0957 45.4307 14.1344 45.1299 14.1846C45.6995 13.542 46.1325 12.847 46.4287 12.0996C46.7295 11.3522 46.8799 10.5342 46.8799 9.64551C46.8799 9.3584 46.8617 9.06217 46.8252 8.75684C46.7887 8.44694 46.7318 8.12337 46.6543 7.78613C46.3717 7.57194 46.0869 7.36686 45.7998 7.1709C45.5173 6.97038 45.2279 6.77441 44.9316 6.58301C45.3509 6.61947 45.736 6.63086 46.0869 6.61719C46.4424 6.60352 46.7865 6.56478 47.1191 6.50098C47.4564 6.43262 47.7959 6.33919 48.1377 6.2207C48.484 6.09766 48.8623 5.94271 49.2725 5.75586L52.1709 10.4863C52.1436 10.2676 52.1253 10.0488 52.1162 9.83008C52.1071 9.61133 52.1025 9.39486 52.1025 9.18066C52.1025 8.5153 52.18 7.86361 52.335 7.22559C52.4899 6.58301 52.7428 5.94727 53.0938 5.31836C53.6224 5.66471 54.1624 5.93359 54.7139 6.125C55.2653 6.31185 55.8509 6.42578 56.4707 6.4668Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1729 5.85156C44.0407 6.61263 43.9427 7.38281 43.8789 8.16211C43.8151 8.93685 43.7832 9.7207 43.7832 10.5137C43.7832 11.1107 43.7992 11.7031 43.8311 12.291C43.8675 12.8789 43.9245 13.4577 44.002 14.0273C43.8333 14.0273 43.6624 14.0205 43.4893 14.0068C43.3161 13.9932 43.1247 13.9863 42.915 13.9863C42.5413 13.9863 42.1562 14.0091 41.7598 14.0547C41.3633 14.1003 40.9395 14.1663 40.4883 14.2529C40.6159 13.6104 40.7184 12.9518 40.7959 12.2773C40.8734 11.6029 40.9121 10.917 40.9121 10.2197C40.9121 9.63639 40.8825 9.05534 40.8232 8.47656C40.764 7.89323 40.6706 7.31217 40.543 6.7334C40.8438 6.7015 41.1354 6.66048 41.418 6.61035C41.7005 6.55566 41.9876 6.49186 42.2793 6.41895C42.571 6.34603 42.8717 6.264 43.1816 6.17285C43.4915 6.07715 43.8219 5.97005 44.1729 5.85156Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8115 14.1982C32.3968 14.1253 32.0299 14.0706 31.7109 14.0342C31.3919 14.0023 31.0775 13.9863 30.7676 13.9863C30.1842 13.9863 29.4984 14.0706 28.71 14.2393C29.0518 13.4463 29.3161 12.6374 29.5029 11.8125C29.6943 10.9876 29.79 10.1354 29.79 9.25586C29.79 8.7181 29.7536 8.18034 29.6807 7.64258C29.6077 7.10026 29.4938 6.54427 29.3389 5.97461C29.6305 6.05664 29.9176 6.12956 30.2002 6.19336C30.4827 6.25716 30.7653 6.31185 31.0479 6.35742C31.3304 6.40299 31.6175 6.43945 31.9092 6.4668C32.2008 6.48958 32.5016 6.50326 32.8115 6.50781C32.8525 7.66992 32.8799 8.83203 32.8936 9.99414C33.2399 9.95768 33.5794 9.92122 33.9121 9.88477C34.2493 9.84375 34.5866 9.80046 34.9238 9.75488C34.974 9.07585 35.0537 8.39453 35.1631 7.71094C35.2725 7.02734 35.4274 6.33236 35.6279 5.62598C35.8877 5.73079 36.1338 5.81966 36.3662 5.89258C36.6032 5.96094 36.8379 6.0179 37.0703 6.06348C37.3027 6.10449 37.5374 6.13639 37.7744 6.15918C38.0114 6.17741 38.262 6.18652 38.5264 6.18652H38.998C38.7383 6.68327 38.5218 7.18229 38.3486 7.68359C38.18 8.1849 38.057 8.69987 37.9795 9.22852C38.1846 9.18294 38.3896 9.13737 38.5947 9.0918C38.8044 9.04622 39.014 8.99837 39.2236 8.94824C39.1416 9.44954 39.1006 9.97135 39.1006 10.5137C39.1006 10.7734 39.1097 11.0355 39.1279 11.2998C39.1507 11.5596 39.1826 11.8148 39.2236 12.0654C39.0049 12.0563 38.793 12.0495 38.5879 12.0449C38.3874 12.0358 38.1846 12.0244 37.9795 12.0107C38.0296 12.348 38.0934 12.6852 38.1709 13.0225C38.2529 13.3597 38.3532 13.6992 38.4717 14.041C38.3441 14.0365 38.2347 14.0319 38.1436 14.0273C38.0524 14.0273 37.9704 14.0251 37.8975 14.0205C37.8291 14.0205 37.7653 14.0182 37.7061 14.0137C37.6468 14.0137 37.5876 14.0137 37.5283 14.0137C37.1318 14.0137 36.7331 14.0479 36.332 14.1162C35.9355 14.1891 35.5003 14.2939 35.0264 14.4307C34.9762 13.9613 34.9375 13.4896 34.9102 13.0156C34.8828 12.5371 34.8691 12.0495 34.8691 11.5527C34.5273 11.4753 34.1947 11.3887 33.8711 11.293C33.5475 11.1973 33.2217 11.097 32.8936 10.9922C32.8844 11.5254 32.873 12.0586 32.8594 12.5918C32.8503 13.125 32.8343 13.6605 32.8115 14.1982Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1562 10.623C28.0833 11.1927 27.9535 11.6872 27.7666 12.1064C27.5798 12.5257 27.3542 12.8857 27.0898 13.1865C26.8255 13.4827 26.5316 13.7266 26.208 13.918C25.8844 14.1094 25.5495 14.2598 25.2031 14.3691C24.8568 14.4785 24.5081 14.5537 24.1572 14.5947C23.8109 14.6357 23.4782 14.6562 23.1592 14.6562C22.3434 14.6562 21.596 14.54 20.917 14.3076C20.238 14.0752 19.6387 13.7266 19.1191 13.2617C18.5996 12.7969 18.1644 12.2158 17.8135 11.5186C17.4671 10.8167 17.2188 10.001 17.0684 9.07129C17.1732 9.10775 17.2848 9.14193 17.4033 9.17383C17.5218 9.20573 17.6403 9.23307 17.7588 9.25586C17.8408 8.33073 18.0824 7.51953 18.4834 6.82227C18.8844 6.12044 19.404 5.53483 20.042 5.06543C20.6846 4.59147 21.4251 4.236 22.2637 3.99902C23.1068 3.75749 24.0114 3.63672 24.9775 3.63672C25.4196 3.63672 25.8913 3.65951 26.3926 3.70508C26.8984 3.75065 27.4408 3.82585 28.0195 3.93066C27.8874 4.34538 27.7871 4.76237 27.7188 5.18164C27.6549 5.59635 27.623 6.01107 27.623 6.42578C27.623 6.86328 27.6572 7.29622 27.7256 7.72461C27.4567 7.52409 27.1878 7.35775 26.9189 7.22559C26.6501 7.08887 26.3857 6.98177 26.126 6.9043C25.8708 6.82227 25.6201 6.7653 25.374 6.7334C25.1279 6.69694 24.8932 6.67871 24.6699 6.67871C24.2507 6.67871 23.8177 6.73796 23.3711 6.85645C22.9245 6.97038 22.5007 7.139 22.0996 7.3623C21.7031 7.58561 21.3477 7.85905 21.0332 8.18262C20.7188 8.50163 20.484 8.86849 20.3291 9.2832C20.516 9.25586 20.696 9.22168 20.8691 9.18066C21.0423 9.13509 21.2132 9.08496 21.3818 9.03027C21.3545 9.23079 21.3408 9.41764 21.3408 9.59082C21.3408 10.0192 21.416 10.402 21.5664 10.7393C21.7168 11.0719 21.9219 11.3545 22.1816 11.5869C22.4414 11.8148 22.749 11.9902 23.1045 12.1133C23.46 12.2318 23.8428 12.291 24.2529 12.291C24.4854 12.291 24.7497 12.2705 25.0459 12.2295C25.3467 12.1839 25.6657 12.1019 26.0029 11.9834C26.3402 11.8604 26.6911 11.6917 27.0557 11.4775C27.4202 11.2588 27.7871 10.974 28.1562 10.623Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4V0L7 0V4H6Z",
    fill: "url(#paint9_linear_101_1063)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.36756C5.9065 2.88121 7.00056 2.87376 9 3.36756V5.631C6.99904 6.14187 5.90811 6.10376 4 5.631V3.36756Z",
    fill: "url(#paint10_linear_101_1063)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8C13 10.2091 10.0899 12 6.5 12C2.91015 12 0 10.2091 0 8C0 5.79086 2.91015 4 6.5 4C10.0899 4 13 5.79086 13 8Z",
    fill: "url(#paint11_linear_101_1063)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.3676C5.9065 9.88121 7.00056 9.87376 9 10.3676V12.631C6.99904 13.1419 5.90811 13.1038 4 12.631V10.3676Z",
    fill: "url(#paint12_linear_101_1063)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.4999C5.9065 12.0135 7.00056 12.0061 9 12.4999V12.7505C6.99904 13.2613 5.90811 13.2232 4 12.7505V12.4999Z",
    fill: "#B57E10"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61325 18.5L6.5 13.5L9.38675 18.5H3.61325Z",
    fill: "#B00000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 14V12.5H7V14H6Z",
    fill: "url(#paint13_linear_101_1063)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02455 13.3578C6.18202 12.9081 6.81797 12.9081 6.97543 13.3578V13.3578C7.04479 13.5558 7.22966 13.6901 7.43945 13.6949V13.6949C7.91578 13.7057 8.1123 14.3105 7.73329 14.5992V14.5992C7.56636 14.7264 7.49574 14.9437 7.55605 15.1447V15.1447C7.69297 15.6011 7.17848 15.9749 6.78677 15.7036V15.7036C6.61425 15.5842 6.38574 15.5842 6.21321 15.7036V15.7036C5.82151 15.9749 5.30702 15.6011 5.44394 15.1447V15.1447C5.50424 14.9437 5.43363 14.7264 5.2667 14.5992V14.5992C4.88769 14.3105 5.08421 13.7057 5.56054 13.6949V13.6949C5.77033 13.6901 5.9552 13.5558 6.02455 13.3578V13.3578Z",
    fill: "url(#paint14_linear_101_1063)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_101_1063",
    x1: 118,
    y1: 1.13257,
    x2: 65.0728,
    y2: 52.1783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0781446,
    stopColor: "#FFD771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166691,
    stopColor: "#FFC83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276073,
    stopColor: "#CA9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421915,
    stopColor: "#E3A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578174,
    stopColor: "#FFB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656304,
    stopColor: "#FFDA79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724016,
    stopColor: "#FFEBB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828189,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942779,
    stopColor: "#E0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_101_1063",
    x1: 118,
    y1: 1.13257,
    x2: 65.0728,
    y2: 52.1783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0781446,
    stopColor: "#FFD771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166691,
    stopColor: "#FFC83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276073,
    stopColor: "#CA9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421915,
    stopColor: "#E3A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578174,
    stopColor: "#FFB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656304,
    stopColor: "#FFDA79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724016,
    stopColor: "#FFEBB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828189,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942779,
    stopColor: "#E0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_101_1063",
    x1: 118,
    y1: 1.13257,
    x2: 65.0728,
    y2: 52.1783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0781446,
    stopColor: "#FFD771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166691,
    stopColor: "#FFC83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276073,
    stopColor: "#CA9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421915,
    stopColor: "#E3A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578174,
    stopColor: "#FFB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656304,
    stopColor: "#FFDA79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724016,
    stopColor: "#FFEBB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828189,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942779,
    stopColor: "#E0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_101_1063",
    x1: 118,
    y1: 1.13257,
    x2: 65.0728,
    y2: 52.1783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0781446,
    stopColor: "#FFD771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166691,
    stopColor: "#FFC83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276073,
    stopColor: "#CA9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421915,
    stopColor: "#E3A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578174,
    stopColor: "#FFB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656304,
    stopColor: "#FFDA79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724016,
    stopColor: "#FFEBB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828189,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942779,
    stopColor: "#E0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_101_1063",
    x1: 118,
    y1: 1.13257,
    x2: 65.0728,
    y2: 52.1783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0781446,
    stopColor: "#FFD771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166691,
    stopColor: "#FFC83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276073,
    stopColor: "#CA9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421915,
    stopColor: "#E3A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578174,
    stopColor: "#FFB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656304,
    stopColor: "#FFDA79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724016,
    stopColor: "#FFEBB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828189,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942779,
    stopColor: "#E0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_101_1063",
    x1: 6.93347,
    y1: 5.19954,
    x2: 4.4439,
    y2: 1.76234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0781446,
    stopColor: "#FFD771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166691,
    stopColor: "#FFC83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276073,
    stopColor: "#CA9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421915,
    stopColor: "#E3A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578174,
    stopColor: "#FFB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656304,
    stopColor: "#FFDA79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724016,
    stopColor: "#FFEBB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828189,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942779,
    stopColor: "#E0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_101_1063",
    x1: 9,
    y1: 5,
    x2: 3.8652,
    y2: 4.74624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0781446,
    stopColor: "#FFD771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166691,
    stopColor: "#FFC83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276073,
    stopColor: "#CA9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421915,
    stopColor: "#E3A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578174,
    stopColor: "#FFB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656304,
    stopColor: "#FFDA79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724016,
    stopColor: "#FFEBB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828189,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942779,
    stopColor: "#E0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_101_1063",
    x1: 6.5,
    y1: 4,
    x2: 6.5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#650000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_101_1063",
    x1: 9,
    y1: 12,
    x2: 3.8652,
    y2: 11.7462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0781446,
    stopColor: "#FFD771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166691,
    stopColor: "#FFC83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276073,
    stopColor: "#CA9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421915,
    stopColor: "#E3A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578174,
    stopColor: "#FFB801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656304,
    stopColor: "#FFDA79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724016,
    stopColor: "#FFEBB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828189,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942779,
    stopColor: "#E0A100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_101_1063",
    x1: 6.10114,
    y1: 12.7898,
    x2: 6.11648,
    y2: 13.8169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4A400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC122"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_101_1063",
    x1: 6.49999,
    y1: 12.0001,
    x2: 6.49999,
    y2: 17.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#670000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChineseNy);
export default __webpack_public_path__ + "static/media/chinese-ny.6df52aff.svg";
export { ForwardRef as ReactComponent };